import React, { Component } from 'react';
import moment from 'moment';

import { ROUTES, TRIAL_SIGNUP_ROUTES } from 'constants/Routes';
import { FREE_SIGNUP_STEPS } from 'constants/Transactions';
import TrialPlan from './TrialPlan';
import PaidPlan from './PaidPlan';
import { setSelectedPlan } from '../../constants/localStorageManager';

class SelectPlan extends Component {
  constructor() {
    super();
    this.state = {
      basicPlanSelected: false,
    };
  }

  onTrialSelected = plan => {
    const { history } = this.props;
    const trialLength = 7;
    const startDate = new Date();
    const endDate = moment(startDate).add(trialLength, 'days');

    const plan_data = {
      start_date: startDate,
      end_date: endDate,
      plan_id: 1,
      status: 'active',
    };

    setSelectedPlan(plan_data);
    history.push(TRIAL_SIGNUP_ROUTES.BUSINESS_DETAILS);
  };

  onBasicPlanSelected = plan => {
    const { id, interval, status } = plan;
    const startDate = new Date();
    const isMonthly = interval === 'monthly';
    const subscriptionLength = isMonthly ? 30 : 365;
    const endDate = moment(startDate).add(subscriptionLength, 'days');
    const billing_rate = isMonthly ? '89' : '1015';
    const plan_data = {
      plan_id: id,
      plan_name: 'basic',
      billing_frequency: interval,
      billing_rate,
      status,
      start_date: startDate,
      end_date: endDate,
    };
    this.onPlanSelected(plan_data);
  };

  onProPlanSelected = plan => {
    const { id, interval, status } = plan;
    const startDate = new Date();
    const isMonthly = interval === 'monthly';
    const subscriptionLength = isMonthly ? 30 : 365;
    const billing_rate = isMonthly ? '129' : '1389';
    const endDate = moment(startDate).add(subscriptionLength, 'days');
    const plan_data = {
      plan_id: id,
      plan_name: 'pro',
      billing_frequency: interval,
      billing_rate,
      status,
      start_date: startDate,
      end_date: endDate,
    };
    this.onPlanSelected(plan_data);
  };

  onPlanSelected = plan => {
    const { location } = this.props;
    setSelectedPlan(plan);
    this.changeStep(location.pathname);
  };

  togglePlan = () => {
    this.setState(prevState => ({
      basicPlanSelected: !prevState.basicPlanSelected,
    }));
  };

  changeStep = currentPathName => {
    const currentStepObj = FREE_SIGNUP_STEPS.find(
      step => step.path == currentPathName
    );
    const currentStepNumber = FREE_SIGNUP_STEPS.indexOf(currentStepObj);
    const lastStep = currentStepNumber == FREE_SIGNUP_STEPS.length - 1;
    if (lastStep) return this.props.history.push(ROUTES.DASHBOARD_INDEX);
    const nextStep = FREE_SIGNUP_STEPS[currentStepNumber + 1];
    this.props.history.push(nextStep.path);
  };

  render() {
    const { basicPlanSelected } = this.state;

    if (basicPlanSelected) {
      return (
        <TrialPlan
          togglePlan={this.togglePlan}
          onPlanSelected={this.onTrialSelected}
        />
      );
    }

    return (
      <PaidPlan
        togglePlan={this.togglePlan}
        onProPlanSelected={this.onProPlanSelected}
        onBasicPlanSelected={this.onBasicPlanSelected}
      />
    );
  }
}

export default SelectPlan;



// WEBPACK FOOTER //
// ./src/components/transactions/SelectPlan.js